import { DateTime } from "@bounce/date"

export function getJsDate(date: DateTime | string): Date {
  if (typeof date === "string") {
    return new Date(date)
  }

  return date.toJSDate()
}

export function getDateTime(date: DateTime | string): DateTime {
  if (typeof date === "string") {
    return DateTime.fromISO(date)
  }

  return date
}
